<template>
  <div>
    <div v-if="isAdmin || isSuperAdmin || isLogist" class="admin__panel">
      <div class="swiper-container admin__panel-list">
        <div class="swiper-wrapper">
          <router-link
            class="admin__panel-item swiper-slide"
            v-for="(item, index) in menu"
            :key="index"
            :to="item.to"
          >
            {{ item.text }}
          </router-link>
        </div>
      </div>
      <div class="admin__panel-right">
        <div class="tabs-swiper__btn tabs-swiper__btn--prev">
          <svgicon
            icon="arrow"
            width="14px"
            class="btn-icon"
          ></svgicon>
        </div>
        <div class="tabs-swiper__btn tabs-swiper__btn--next">
          <svgicon
            icon="arrow"
            width="14px"
            class="btn-icon"
          ></svgicon>
        </div>

        <div class="vl"></div>

        <Button
          v-if="isSuperAdmin"
          iconWidth="20px"
          icon="settings"
          width="20px"
          class="settings"
          @click="$router.push({ name: 'Settings' })"
        />
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import { mapGetters } from "vuex";
import Swiper, { Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

export default {
  name: "AdminPanel",
  components: {
    Button,
  },
  data () {
    return {
      menu: [
        {
          to: 'admins',
          text: 'Администраторы'
        },
        {
          to: 'passengers',
          text: 'Внешние пассажиры'
        },
        {
          to: 'logisticians',
          text: 'Логисты'
        },
        {
          to: 'users',
          text: 'Пользователи'
        },
        {
          to: 'departments',
          text: 'Подразделения'
        },
        {
          to: 'osr-staff',
          text: 'Сотрудники ОСР'
        },
        {
          to: 'filiations',
          text: 'Филиалы'
        },
        {
          to: 'contracts',
          text: 'Договоры с агентством'
        },
        {
          to: 'cards',
          text: 'Карты лояльности'
        },
        {
          to: 'return-reasons',
          text: 'Причины обмена/возврата'
        }
      ],
      activeTab: null
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper('.admin__panel-list', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      initialSlide: this.activeTab,
      navigation: {
        prevEl: '.tabs-swiper__btn--prev',
        nextEl: '.tabs-swiper__btn--next'
      },
      breakpoints: {
        1300: {
          spaceBetween: 20,
        }
      }
    })
    }
  },
  computed: {
    ...mapGetters("users", ["isSuperAdmin", "isAdmin", "isLogist"]),
  },
  watch: { 
    '$route.path': {
      handler(path) {
        this.menu.some((item, index) => {
          if (item.to ===  path.split("/").pop()) this.activeTab = index
        })
        this.initSwiper()
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.admin__panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 64px;
  width: 100%;
  background: #F1F6F9;
  border-radius: 4px;
  margin-bottom: 32px;
  padding: 0 32px;
  font-size: 16px;

  &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 20px;
      height: 100%;
      width: 40px;
      background: linear-gradient(to left, rgba(255, 255, 255, 0), #F1F6F9 100%);
      pointer-events: none;
      z-index: 2;

      @media screen and (max-width:1500px) {
        left: 12px;
      }
    }

  @media screen and (max-width:1500px) {
    height: 48px;
    padding: 0 20px;
    font-size: 14px;
  }

  .swiper-wrapper {
    justify-content: space-between;
  }

  &-right {
    position: relative;
    display: flex;
    align-items: center;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: -70px;
      height: 100%;
      width: 40px;
      background: linear-gradient(to right, rgba(255, 255, 255, 0), #F1F6F9 100%);
      pointer-events: none;
      z-index: 1;
    }
  }

  &-list {
    display: flex;
    align-items: center;
    width: calc(100% - 160px);
    height: 100%;
    overflow: hidden;
    padding: 0 20px;
  }

  &-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    transition: 0.2s linear;
    line-height: 24px;
    width: auto !important;
  }

  .settings {
    font-size: 16px;
    color: $light-black;

    &:hover {
      color: $dark-blue;
      fill: $dark-blue;
    }
  }

  .vl {
    display: block;
    border-left: 1px solid $gray;
    height: 36px;
    margin: 0 16px;
  }

  .tabs-swiper__btn {
    background: white;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;

    &:hover .btn-icon{
      fill: $dark-blue;
    }

    &.swiper-button-disabled path{
      fill: #B8CAD5;
    }
  }

  .tabs-swiper__btn--prev {
    transform: rotate(90deg);
    margin-right: 10px;
  }

  .tabs-swiper__btn--next {
    transform: rotate(-90deg)
  }

  .router-link-active {
    color: $blue;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      display: flex;
      width: 100%;
      border: 2px solid $blue;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  }
}
</style>
